import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot, ActivationEnd } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit {
  title = 'Home';
  usuario: any;
  enviromentAmbiente: string;
  constructor(private route: ActivatedRoute, private router: Router, private loginService: LoginService) { 
    this.enviromentAmbiente = environment.ambiente;
    
  }

  ngOnInit() {
    this.loginService.getLogIn().subscribe(l => this.usuario = l);
    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        if (!event.snapshot.firstChild) {
          this.title = event.snapshot.data['title'];
        }
      }
    });
  }

}
